import React from "react";
import { useLocation } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

export default function Route({
  name = "Route name",
  icon,
  onClick = null,
  urlPath = "",
  isCollapsed = false, // 👈 receives from NavBar
}) {
  const location = useLocation();
  const path = location.pathname.split("/")[2];
  const isActive = urlPath === path;

  return (
    <div
      onClick={onClick}
      className={`mx-3 my-0.5 flex items-center px-4 py-2.5 cursor-pointer transition-all rounded-full group ${
        isActive
          ? "bg-blue-100 text-blue-800 font-semibold"
          : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
      } ${isCollapsed ? "justify-center px-0 w-10 h-10 mx-auto rounded-full" : "gap-4"}`}
    >
      <div className={`${isCollapsed ? "text-xl" : "text-lg"} ${isActive ? "text-blue-700" : "text-gray-500 group-hover:text-gray-700"}`}>
        {icon}
      </div>

      {!isCollapsed && (
        <div className="flex justify-between items-center w-full text-sm font-medium tracking-wide">
          <span>{name}</span>
          {/* Optional: Add chevron only if it's a dropdown parent, otherwise keep clean */}
        </div>
      )}
    </div>
  );
}
